import dayjs, { Dayjs } from "dayjs";
import ru from "dayjs/locale/ru";
import isTodayDJ from "dayjs/plugin/isToday";
import isTomorrowDJ from "dayjs/plugin/isTomorrow";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AGE_RESTRICTIONS } from "constants/variables";

dayjs.locale(ru);
dayjs.extend(customParseFormat);
dayjs.extend(isTodayDJ);
dayjs.extend(isTomorrowDJ);

type DateInput = Common.Date | Dayjs;

/* todo: delete this later */
export function parseFromFormat(date: DateInput, formatting?: string): Dayjs {
  return dayjs(date, formatting);
}
export function formatDate(date: DateInput, formatting?: string): string {
  return dayjs(date).format(formatting);
}

export function formatDeliveryDate(date: DateInput): string {
  const targetDate = dayjs(date);
  if (targetDate.isToday()) {
    return "сегодня";
  } else if (targetDate.isTomorrow()) {
    return "завтра";
  } else if (targetDate.subtract(1, "day").isTomorrow()) {
    return "послезавтра";
  } else {
    return dayjs(date).format("DD.MM.YYYY");
  }
}

export function formatPreOrderDate(date: DateInput): string {
  const targetDate = dayjs(date);

  if (targetDate.get("hours"))
    return `Забрать после ${targetDate.get("hours")}:00`;

  if (targetDate.isToday()) {
    return "Забрать сейчас";
  } else if (targetDate.isTomorrow()) {
    return "Забрать завтра";
  } else if (targetDate.subtract(1, "day").isTomorrow()) {
    return "Забрать послезавтра";
  } else {
    return "Забрать " + dayjs(date).format("DD MMMM");
  }
}

export const getMaxDateGenerate = (ageFrom = AGE_RESTRICTIONS.FROM) => {
  const date = new Date();

  return new Date(
    `${date.getFullYear() - ageFrom}/${date.getMonth() + 1}/${date.getDate()}`
  );
};

export function monthDiff(from: Date, to: Date): number {
  let months =
    to.getMonth() -
    from.getMonth() +
    12 * (to.getFullYear() - from.getFullYear());

  if (to.getDate() < from.getDate()) {
    months--;
  }

  return months;
}

export function isToday(date: DateInput): boolean {
  return dayjs(date).isToday();
}
const daysConst = {
  Понедельник: { day: "Пн", num: 1 },
  Вторник: { day: "Вт", num: 2 },
  Среда: { day: "Ср", num: 4 },
  Четверг: { day: "Чт", num: 8 },
  Пятница: { day: "Пт", num: 16 },
  Суббота: { day: "Сб", num: 32 },
  Воскресенье: { day: "Вс", num: 64 },
};
export function formateWorkingDays(days: Array<string>): string {
  const temp = days
    .sort((day1, day2) => daysConst[day1].num - daysConst[day2].num)
    .map(day => daysConst[day]);
  switch (
    temp.reduce((a, b) => {
      return a + b.num;
    }, 0)
  ) {
    case 127:
      return "Пн-Вс";
    case 31:
      return "Будни";
    case 96:
      return "Сб,Вс";
    default:
      return temp.map(i => i.day).join(",");
  }
}

export function pharmacyWorkingDays(
  pharmacy: Partial<Entity.PharmacyCard>
): Array<{
  day: string;
  time: string;
}> {
  if (!pharmacy?.workingHours) return null;
  if (!Array.isArray(pharmacy?.workingHours)) return null;
  if (pharmacy.workingHours.length === 0) return null;
  const wh = new Map();

  pharmacy.workingHours
    .map(item => {
      return { name: item.name, time: `${item.open} – ${item.close}` };
    })
    .forEach(item => {
      if (wh.has(item.time)) {
        wh.set(item.time, [...wh.get(item.time), item.name]);
      } else {
        wh.set(item.time, [item.name]);
      }
    });

  const workingHours = Object.fromEntries(wh);

  return Object.keys(workingHours).map(time => ({
    day: formateWorkingDays(workingHours[time]),
    time,
  }));
}

export function minutesDiff(from: DateInput, to: DateInput): number {
  const date = dayjs(from);

  return date.diff(to, "minutes");
}
